// extracted by mini-css-extract-plugin
export default {"dropdown":"dropdown_dropdown__kodX+","dropdown_content":"dropdown_dropdown_content__1R6ZX"};